import { useEffect, useRef } from 'react'

const VAR = '--app-header-h'

export function useHeaderHeight<T extends HTMLElement>() {
  const ref = useRef<T>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const root = document.documentElement
    const apply = () => root.style.setProperty(VAR, `${Math.round(el.getBoundingClientRect().height)}px`)
    const mark = () => {
      el.dataset.scrolled = window.scrollY > 0 ? 'true' : 'false'
    }
    apply()
    mark()
    const observer = new ResizeObserver(apply)
    observer.observe(el)
    window.addEventListener('scroll', mark, { passive: true })
    return () => {
      observer.disconnect()
      window.removeEventListener('scroll', mark)
      root.style.removeProperty(VAR)
    }
  }, [])

  return ref
}
